// extracted by mini-css-extract-plugin
export default {"Tags":"Tags__Tags___XtDVb","clearTags":"Tags__clearTags___AY5i9","tagItem":"Tags__tagItem___RPfLG","clearButton":"Tags__clearButton___SZqpG"};